<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">About</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
  <div class="ttmodal__body about-modal">
    <div class="site-code">Site Code  : {{SiteCode}}</div>
    <div class="copy-right"> Copyright 
      &copy;
   {{CurrentYear}}
    </div>
    <div class="company-name"> TT Software Services PTY. LTD. </div>
    <div class="email"> <a href="mailto:help@tracktreads.com">help@tracktreads.com</a> </div>
  </div>
  <div class="ttmodal__footer ok-button">
    <button  mat-raised-button color="primary" (click)="onNoClick()">Ok</button>
  </div>
</div>
